import apiClient from '../apiClient';

const BASE = '/client-admin';

export const getAuditLog = (params = {}) => apiClient.get(`${BASE}/audit-log`, params);
export const getActionTypes = () => apiClient.get(`${BASE}/audit-log/actions`);
